// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../node_modules/css-loader/dist/cjs.js!react-toastify/dist/ReactToastify.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap);"]);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "body {\n  margin: 0;\n  font-family: 'Open Sans', serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na {\n  text-decoration: none;\n}\n\ntextarea, input, select, button {\n  font-family: 'Open Sans', serif;\n}\n\n*,\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n", ""]);
// Exports
module.exports = exports;
